import {
    MobilePortfolioRespawnBackgroundStyled,
    MobilePortfolioRespawnCloseButtonStyled,
    MobilePortfolioRespawnContentStyled,
    MobilePortfolioRespawnImageWrapperStyled,
    MobilePortfolioRespawnStyled
} from "./styled/MobilePortfolioRespawnStyled";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { Button } from "react-bootstrap";
import { BinIcon } from "../../../components/icon/Icon";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { openMobileSliderPageAction } from "../../mobileAppActions";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";

function MobilePortfolioRespawn(props) {
    const {handleClose} = props;
    const {getLangPath} = useLangContext();

    const dispatch = useDispatch();

    const handleButtonClick = useCallback((e) => {
        e.preventDefault();
        dispatch(openMobileSliderPageAction(MOBILE_SLIDER_PAGES_IDS.RESPAWN));
        handleClose();
    }, [dispatch, handleClose]);

    return <MobilePortfolioRespawnStyled>
        <MobilePortfolioRespawnCloseButtonStyled onClick={handleClose}>
            <BinIcon name={'IcClose'}/>
        </MobilePortfolioRespawnCloseButtonStyled>
        <MobilePortfolioRespawnContentStyled>
            <MobilePortfolioRespawnBackgroundStyled/>
            <MobilePortfolioRespawnImageWrapperStyled>
                <img src={`${process.env.PUBLIC_URL}/assets/bonus/bonus-respawn-dollar.png`}
                     alt="bonus-respawn-dollar"/>
            </MobilePortfolioRespawnImageWrapperStyled>
            <h2 dangerouslySetInnerHTML={{__html: getLangPath('bonus.new_life.start_banner.title')}}/>
            <p>{getLangPath('bonus.new_life.start_banner.description')}</p>
            <Button variant={'primary'} size={'lg'} onClick={handleButtonClick}>
                {getLangPath('bonus.new_life.start_banner.button')}
            </Button>
        </MobilePortfolioRespawnContentStyled>
    </MobilePortfolioRespawnStyled>
}

export default MobilePortfolioRespawn;
